import React from "react";

import { Plan } from "@/types";

import AppTable from "@/components/AppTable";
import AppTableContainer from "@/components/AppTableContainer";
import AppTableHead from "@/components/AppTable/AppTableHead";
import AppTableBody from "@/components/AppTable/AppTableBody";
import AppTableRow from "@/components/AppTable/AppTableRow";
import AppTableCell from "@/components/AppTable/AppTableCell";
import AppTableHeaderCell from "@/components/AppTable/AppTableHeaderCell";
import AppSwitch from "@/components/AppSwitch";
import AppIcon from "@/components/AppIcon";
import AppText from "@/components/AppText";
import AppTooltip from "@/components/AppTooltip";
import AppBox from "@/components/AppBox";

interface PlansTableProps {
  tableRows: Plan[];
  onEdit: (row: Plan) => void;
  onDelete: (row: Plan) => void;
  onChangeDefaultPlan: (row: Plan) => void;
}

const PlansTable: React.FC<PlansTableProps> = ({
  tableRows,
  onEdit,
  onDelete,
  onChangeDefaultPlan,
}) => {
  return (
    <AppTableContainer>
      <AppTable>
        {/* Table Head */}
        <AppTableHead>
          <AppTableRow>
            <AppTableHeaderCell>Name</AppTableHeaderCell>
            <AppTableHeaderCell>API ID</AppTableHeaderCell>
            <AppTableHeaderCell align="center">Trial</AppTableHeaderCell>
            <AppTableHeaderCell align="center">Default Plan</AppTableHeaderCell>
            <AppTableHeaderCell align="center">Actions</AppTableHeaderCell>
          </AppTableRow>
        </AppTableHead>

        {/* Table Body */}
        <AppTableBody>
          {tableRows.length > 0 ? (
            tableRows.map((row) => (
              <AppTableRow
                key={row.id}
                className="border-t hover:bg-gray-50 transition-colors"
              >
                {/* Name */}
                <AppTableCell className="py-4">
                  <AppText>{row.name}</AppText>
                </AppTableCell>

                {/* API ID */}
                <AppTableCell>
                  <AppText>{row.api_id}</AppText>
                </AppTableCell>

                {/* Trial */}
                <AppTableCell align="center">
                  <AppText>{row.trial}</AppText>
                </AppTableCell>

                {/* Default Plan Switch */}
                <AppTableCell align="center">
                  <AppSwitch
                    checked={!!row.current}
                    onChange={() => onChangeDefaultPlan(row)}
                  />
                </AppTableCell>

                {/* Actions */}
                <AppTableCell align="center">
                  <AppBox inline>
                    <AppTooltip title="Delete Plan">
                      <AppIcon
                        name="trash"
                        className="text-error hover:text-error-hover cursor-pointer"
                        onClick={() => onDelete(row)}
                      />
                    </AppTooltip>
                  </AppBox>
                </AppTableCell>
              </AppTableRow>
            ))
          ) : (
            <AppTableRow>
              <AppTableCell colSpan={5} className="text-center p-4">
                <AppText>No results</AppText>
              </AppTableCell>
            </AppTableRow>
          )}
        </AppTableBody>
      </AppTable>
    </AppTableContainer>
  );
};

export default PlansTable;